import { useAuiState } from '@assistant-ui/react';
import { useStore } from 'zustand';
import { useNamespaceCopy } from '@/i18n/ns';
import copy from '@/i18n/ns/voice-interruption';
import { interruptionStore, isInterruptionMarker } from './interruption';

export function InterruptedReply() {
  const strings = useNamespaceCopy(copy);
  const messageId = useAuiState((state) => state.message.id);
  const local = useStore(interruptionStore, (state) => state.messages.includes(messageId));
  const retained = useAuiState((state) =>
    state.thread.messages.some(
      (message) =>
        message.role === 'user' &&
        message.content.some((part) => isInterruptionMarker(part, messageId)),
    ),
  );
  if (!local && !retained) return null;
  return (
    <span
      role="status"
      data-slot="voice-interrupted-reply"
      className="text-muted-foreground text-sm"
    >
      {strings.interrupted}
    </span>
  );
}
